import React from "react";

const About = ({ commonData }) => (
  <div
    className="about-dellworks p-4"
    id={commonData.aboutSlug}
  >
    <div className="section-title">
      {commonData.aboutDwellworksSectionHeading}
    </div>
    <div className="about-dellworks-content">
      {commonData.aboutDwellworksContent &&
        commonData.aboutDwellworksContent.map(function (item, index) {
          return (
            <div key={index} className="d-box">
              <div className="d-icon bgpurple">
                {item.headIcon && (
                  <img src={item.headIcon._url} alt={item.headIcon.name} />
                )}
              </div>
              <div className="d-head purple">{item.headText}</div>
              <div
                className="d-cont"
                dangerouslySetInnerHTML={{ __html: item.headContent }}
              ></div>
            </div>
          );
        })}
    </div>
  </div>
);

export default About;
